// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"2df390f6","220":"649eebb0","276":"8e6df0ff","339":"029f58cc","707":"2d0e017f","761":"e4f2fc48"}[chunkId] + ".chunk.js";
};